import {
  DeleteOutlineRoundedIcon,
  EditOutlinedIcon,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
} from '@shared/components';
import { usePermission } from '@shared/permissions';
import { APP_PERMISSIONS } from '@user-management/permissions';
import { useRoleManagementModal } from '@user-management/role-management';
import { useNavigate } from '@user-management/router';
import { useMemo } from 'react';

interface RoleListMenuProps {
  roleId: string;
}

interface MoreActionMenuOption extends MoreMenuIconButtonOption {
  requiredPermission: string[];
}

export default function RoleListMenu(props: Readonly<RoleListMenuProps>) {
  const { roleId } = props;

  const navigate = useNavigate();
  const { setAction } = useRoleManagementModal();
  const { permissions } = usePermission();

  const handleEdit = () => {
    navigate('/roles-and-permissions/:appRoleId/details', { params: { appRoleId: roleId } });
  };

  const handleDelete = () => {
    setAction('role-deletion', roleId);
  };

  const options: MoreActionMenuOption[] = [
    {
      icon: <EditOutlinedIcon />,
      label: 'Edit',
      onClick: handleEdit,
      requiredPermission: [APP_PERMISSIONS.SETTING.ROLE.UPDATE],
    },
    {
      icon: <DeleteOutlineRoundedIcon color='error' />,
      label: 'Delete',
      onClick: handleDelete,
      sx: (theme) => ({ color: theme.palette.error.main }),
      requiredPermission: [APP_PERMISSIONS.SETTING.ROLE.DELETE],
    },
  ];

  const filteredOptions = useMemo(
    () =>
      options.filter((option) =>
        option.requiredPermission.every((reqPermission) => permissions.includes(reqPermission)),
      ),
    [options, permissions],
  );

  return <MoreMenuIconButton options={filteredOptions} />;
}
